@let user = user$ | async;

<div #containerRef class="playlist-detail-container page">
  <div class="header">
    <div class="background">
      @if (playlist?.images['1024x256']) {
        <img [src]="playlist.images['1024x256']" [alt]="playlist.name" />
      }
    </div>
    <button class="back-button" (click)="backButtonClick()" translate>
      <kin-icon [name]="'arrow_left'" [color]="'white'" />
      browse.search.toolbar.back
    </button>
    <div class="playlist-image">
      @if (playlist?.images['512x512']) {
        <img [src]="playlist.images['512x512']" [alt]="playlist.name" />
      } @else {
        <kin-skeleton [borderRadius]="0" unit="px" width="80" height="80" />
      }
    </div>
    <div class="playlist-main-info">
      <span class="playlist-videos-count">
        @if (playlist?.videos_count) {
          <kin-icon name="playlists" color="white" size="24" />
          {{ playlist.videos_count }}
          {{ 'dashboard.profile.slider.videos' | translate }}
        } @else {
          <kin-skeleton [borderRadius]="5" unit="px" width="50" height="25" />
        }
      </span>
      @if (playlist?.name) {
        <h2 class="playlist-title">{{ playlist.name }}</h2>
      } @else {
        <kin-skeleton [borderRadius]="5" unit="px" width="120" height="32" />
      }
      <div class="author">
        @if (authorCircleData) {
          <kin-circle-user
            (onClick)="redirect(authorCircleData.id, 'author')"
            imgProfileSize="small"
            [circleUserData]="authorCircleData"
            colorTheme="dark" />
        } @else {
          <kin-skeleton [borderRadius]="50" unit="px" width="42" height="42" />
        }
      </div>
      @if (playlist) {
        @if (user) {
          <kin-toggle-icon-btn
            class="fav-btn"
            icon="fav_stroke"
            iconToggle="fav_fill"
            [active]="playlist.is_favorite"
            (onClick)="addPlaylistToFavorite()" />
          <kin-toggle-icon-btn
            class="edit-btn"
            icon="edit"
            iconToggle="edit"
            [color]="editColor"
            [active]="playlist.is_favorite"
            (onClick)="isEditing = !isEditing" />
        }
      } @else {
        <kin-skeleton
          class="fav-btn"
          [borderRadius]="50"
          unit="px"
          width="40"
          height="40" />
      }
    </div>
  </div>
  <div class="playlist-details">
    <div class="data">
      <div class="duration">
        <span class="value">
          @if (playlist?.duration) {
            {{ playlist.duration | duration: 'value' }}
            {{ playlist.duration | duration: 'unit' | uppercase }}
          } @else {
            <kin-skeleton [borderRadius]="5" width="70" height="22" unit="px" />
          }
        </span>
        <span class="label">
          @if (playlist?.duration) {
            <kin-icon name="timer" color="#7E8184" size="24" />
            {{ 'training_log.data.label.duration' | translate }}
          } @else {
            <kin-skeleton
              class="skeleton"
              [borderRadius]="5"
              width="70"
              height="17"
              unit="px" />
          }
        </span>
      </div>
      @if (!playlist || playlist.distance) {
        <div class="distance">
          <div class="value">
            @if (playlist?.distance) {
              {{ playlist.distance | distance: 'value' }}
              {{ playlist.distance | distance: 'unit' | uppercase }}
            } @else {
              <kin-skeleton
                [borderRadius]="5"
                width="70"
                height="22"
                unit="px" />
            }
          </div>
          <div class="label">
            @if (playlist?.duration) {
              <kin-icon
                name="double_arrow"
                color="#7E8184"
                size="24"></kin-icon>
              {{ 'training_log.data.label.distance' | translate }}
            } @else {
              <kin-skeleton
                class="skeleton"
                [borderRadius]="5"
                width="70"
                height="17"
                unit="px" />
            }
          </div>
        </div>
      }
    </div>
    @if (playlist?.description) {
      @if (playlist?.description !== null && playlist.description !== 'null') {
        <p class="description" [innerHTML]="playlist.description"></p>
      } @else {
        <p class="description">
          {{ 'browse.structuredTrainings.noDescriptionAvailable' | translate }}
        </p>
      }
    } @else {
      <kin-skeleton
        class="skeleton"
        [borderRadius]="5"
        width="300"
        height="17"
        unit="px" />
    }
    <div class="display-btns-wrapper">
      <button
        class="display-btn"
        (click)="isMapDisplayed = false"
        [ngClass]="{ active: !isMapDisplayed }">
        <span class="icon icon-all-liste"></span>
        <span class="display-btn-label">{{
          'browse.search.toolbar.listDisplay' | translate
        }}</span>
      </button>
      <button
        class="display-btn"
        (click)="isMapDisplayed = true"
        [ngClass]="{ active: isMapDisplayed }">
        <span class="icon icon-carte"></span>
        <span class="display-btn-label">{{
          'browse.search.toolbar.mapDisplay' | translate
        }}</span>
      </button>
    </div>
  </div>

  @if (isEditing) {
    <app-edit-playlist
      [playlist]="playlist"
      [loading$]="editionLoading$"
      (onCloseEdit)="isEditing = false"
      (onPlaylistUpdated)="onPlaylistUpdated($event)" />
  } @else {
    @if (!isMapDisplayed) {
      <div
        class="playlists-cards-container"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollDisabled]="loading$ | async"
        [infiniteScrollThrottle]="70"
        (scrolled)="onScrollBottom()">
        @for (video of playlistVideos; track $index) {
          <kin-scenic-card
            [details]="true"
            [information]="video"
            [isRemovable]="playlist.author.id === user?.id"
            (onRemoveClick)="onRemoveClick($event)"
            (onCardClick)="redirect(video.id, 'browse', video?.type)"
            (onAuthorClick)="redirect(video.author.id, 'author')"
            (onFavoriteClick)="onLikeClick(video)" />
        }
        @if (loading$ | async) {
          @for (index of [].constructor(8); track $index) {
            <kin-scenic-card [details]="true" />
          }
        }
      </div>
    } @else {
      <app-search-map [id]="playlistId" path="playlist" />
    }
  }
</div>
